export default __webpack_public_path__ + "static/media/logo.d1e9fb68.svg";